import React from 'react';
import { Link } from 'react-router-dom';
import ShoppingCart from './ShoppingCart';

/**
 * This component renders the breadcrumb navigation and the shopping cart.
 */
class Breadcrumb extends React.Component {
	render () {
		if (this.props.gearOrder?.physicianInTheLoop) {
			return null;
		}

		const isPrc = this.props.userInfo?.type === 'prc';
		let homeLink, activateLinkText;
		if (isPrc) {
			homeLink = <a href="/prc">Patient Resource Center</a>;
			activateLinkText = 'Activation';
		} else {
			homeLink = <a href="/mygdx">myGDX Home</a>;
			activateLinkText = 'Activate & Order Tests';
		}

		return (
			<div className="page-intro"> 
				<div className="container">
					<div className="row">
						<div className="col-md-11">
							<ol className="breadcrumb">
								<li><i className="fa fa-home pr-10"></i>{homeLink}</li>
								{!this.props.singleLevel && (
									<>
										{this.props.breadcrumbStep === "start" &&
											<li className="active"><span> {activateLinkText} </span></li>
										}
										{this.props.breadcrumbStep !== "start" &&
											<li className="active"><Link to={"/"}> {activateLinkText} </Link></li>
										}
									</>
								)}
								{this.props.breadcrumbStep === "order-list" &&
									<li>
										<span>
											&nbsp;
										</span>
										<span>
											History
										</span>
									</li>
								}
								{this.props.breadcrumbStep !== "start" && this.props.breadcrumbStep !== "order-list" &&
									<li>
										<span>
											&nbsp;
										</span>
										<span>
											{this.props.breadcrumbStep}
										</span>
									</li>
								}
							</ol>
						</div>
						<div className="col-md-1 pull-right">
							<ShoppingCart {...this.props} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Breadcrumb;